import store from '../store';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/firestore';
import {USER_FB_TOKEN_REQUEST} from "../store/actions/user";


export default {
    init() {
        const config = {
            apiKey: process.env.FIREBASE_API_KEY,
            authDomain: process.env.FIREBASE_AUTH_DOMAIN,
            databaseURL: process.env.FIREBASE_DATABASE_URL,
            projectId: process.env.FIREBASE_PROJECT_ID,
            storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
            messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER,
            appId: process.env.FIREBASE_APP_ID,
            measurementId: process.env.FIREBASE_MEASUREMENT_ID
        };
        firebase.initializeApp(config);
        firebase.storage(this.app);
    },
    refreshToken() {
        if (!store.getters.getFbToken) {
            store.dispatch(USER_FB_TOKEN_REQUEST).then((token) => {
                firebase.auth().signInWithCustomToken(token).catch(function (error) {
                    console.error(error);
                });
            });

        } else {
            firebase.auth().signInWithCustomToken(store.getters.getFbToken).catch(function (error) {
                console.error(error);
            });
        }
    },
    getInstance(){
      return firebase;
    },
    getStorage() {
        this.refreshToken();
        return firebase.storage();
    },
    getFirestore() {
        this.refreshToken();
        return firebase.firestore();
    }
}



// WEBPACK FOOTER //
// ./src/services/firebase.js